var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomerSuccess = function SvgCustomerSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 5,
    d: "M13.299 29c5.964 0 10.799-4.834 10.799-10.799 0-5.964-4.835-10.799-10.799-10.799-5.964 0-10.799 4.835-10.799 10.8C2.5 24.164 7.335 29 13.299 29Z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.957.36a1 1 0 0 1 1.64.768v3.775h3.775a1 1 0 0 1 .77 1.64l-3.26 3.91a1 1 0 0 1-.768.36h-3.806l-5.1 5.099a5.418 5.418 0 1 1-1.976-2.264l4.456-4.455V4.386a1 1 0 0 1 .36-.768L24.956.36Z"
  })));
};
export default SvgCustomerSuccess;